import { render, staticRenderFns } from "./ComponentDetail.vue?vue&type=template&id=05f4ae79&scoped=true&"
import script from "./ComponentDetail.vue?vue&type=script&lang=js&"
export * from "./ComponentDetail.vue?vue&type=script&lang=js&"
import style0 from "./ComponentDetail.vue?vue&type=style&index=0&id=05f4ae79&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f4ae79",
  null
  
)

export default component.exports